var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 13.8369C18.4557 14.5683 19.704 15.742 20.6151 17.2096C20.7955 17.5003 20.8857 17.6456 20.9169 17.8468C20.9803 18.2558 20.7006 18.7585 20.3198 18.9204C20.1323 19 19.9215 19 19.4998 19M14.9998 9.53224C16.4816 8.79589 17.4998 7.26686 17.4998 5.5C17.4998 3.73314 16.4816 2.20411 14.9998 1.46776M12.9998 5.5C12.9998 7.98528 10.9851 10 8.49984 10C6.01455 10 3.99984 7.98528 3.99984 5.5C3.99984 3.01472 6.01455 1 8.49984 1C10.9851 1 12.9998 3.01472 12.9998 5.5ZM1.55907 16.9383C3.15337 14.5446 5.66921 13 8.49984 13C11.3305 13 13.8463 14.5446 15.4406 16.9383C15.7899 17.4628 15.9645 17.725 15.9444 18.0599C15.9287 18.3207 15.7578 18.64 15.5494 18.7976C15.2818 19 14.9137 19 14.1775 19H2.82219C2.08601 19 1.71791 19 1.45028 18.7976C1.24189 18.64 1.07092 18.3207 1.05527 18.0599C1.03517 17.725 1.2098 17.4628 1.55907 16.9383Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.0643ec6f9202c4496896ae67ebeab7c4.svg";
export { ForwardRef as ReactComponent };